module.exports = __webpack_public_path__ + "static/bnr-f80be76ca091a7f0b98f7b9f235ebf65.jpg";